import { RRule } from 'rrule'
import moment from 'moment'

const MAX_DATES = 3

const SUBSTITUTIONS = [
  ['daily', 'day'],
  ['weekly', 'week'],
  ['monthly', 'month'],
  ['yearly', 'year'],
  [' one ', ' 1 '],
  [' two ', ' 2 '],
  [' three ', '3 '],
  [' four ', ' 4 '],
  [' five ', ' 5 '],
  [' six ', ' 6 '],
  [' seven ', ' 7 '],
  [' eight ', ' 8 '],
  [' nine ', ' 9 '],
  [' ten ', ' 10 '],
  [' once', ' for 1 time '],
  [' twice', ' for 2 times ']
]
export default class RepeatPattern {
  constructor(pattern) {
    this.updatePattern(pattern)
  }

  toString() {
    return this.pattern
  }

  isValidRepeatPattern() {
    if (!this.pattern) {
      return true
    }

    try {
      const rrule = RRule.fromText(this.pattern)
      return Boolean(rrule.toString())
    } catch (err) {
      return false
    }
  }

  updatePattern(pattern) {
    if (!pattern || pattern.length === 0) {
      return null
    }
    try {
      let cleaned = pattern.toLowerCase()
      if (!cleaned.startsWith('every')) {
        cleaned = 'Every ' + pattern
      }
      SUBSTITUTIONS.forEach(([a, b]) => {
        cleaned = cleaned.replace(a, b)
      })
      cleaned = RRule.fromText(cleaned).toText()
      if (cleaned && cleaned.length > 0) {
        cleaned = cleaned.charAt(0).toUpperCase() + cleaned.slice(1)
      }
      this.pattern = cleaned
    } catch (err) {
      this.pattern = pattern
    }
  }

  nextDates(startDate = moment().startOf('day').toDate(), maxDate = MAX_DATES) {
    if (this.isValidRepeatPattern()) {
      const rule = RRule.fromText(this.pattern)

      if (rule) {
        rule.options.dtstart = startDate

        // Get one more date than needed, so we can filter out today if necessary
        const dates = rule.all((date, i) => {
          if (!rule.options.count && i === maxDate + 1) {
            return false // That's enough
          }
          return true
        })

        if (dates && dates[0]) {
          if (moment(dates[0]).startOf('day').isSame(moment().startOf('day'))) {
            // The first date is today, we don't want that
            dates.splice(0, 1)
          } else {
            // The first date isn't today, so return the first three
            dates.splice(maxDate, 1)
          }
        }
        return dates
      }
    }
    return null
  }

  nextDate(startDate = null, includeToday = true) {
    if (this.isValidRepeatPattern()) {
      const TODAY = moment().startOf('day')

      const rule = RRule.fromText(this.pattern)
      if (rule) {
        rule.options.dtstart = startDate ? startDate : TODAY.toDate()
        // after is supposed to take an option to say whether to include
        // dates that match the first parameter, i.e TODAY, but it's not working.
        // Therefore, if includeToday===false, set the after date to be tomorrow
        const next = rule.after(
          includeToday ? TODAY.toDate() : TODAY.add(1, 'days').toDate()
        )
        if (next) {
          return moment(next).startOf('day').toDate()
        }
      }
    }
    return null
  }
}
